import { FC, SVGAttributes } from 'react';

type EllipseSvgProps = SVGAttributes<SVGElement>;

export const EllipseSvg: FC<EllipseSvgProps> = (props) => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <circle
                cx="20.25"
                cy="19.75"
                r="18.75"
                stroke="#10B5A8"
                strokeWidth="1.60714"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="3.21 6.43"
            />
        </svg>
    );
};
